import { Link } from 'react-router-dom';
import { getLatestUpdates } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function LatestSection() {
  const latestComics = getLatestUpdates(12);

  return (
    <section className="bg-background-100/70 py-12 md:py-16">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              <i className="ri-time-line text-primary-500 mr-2"></i>
              最近更新
            </h2>
            <p className="text-sm text-foreground-500 mt-1">最新更新的漫画章节</p>
          </div>
          <Link
            to="/category/all"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-5">
          {latestComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}